module.exports = __webpack_public_path__ + "catalog/holes/window-curtain/window-curtain.jpg";